<h2 class="dialog-title">Connect to {{ data.destination.name }}</h2>

<div class="dialog-body">

  <mat-form-field appearance="outline" class="field">
    <mat-label>External Account ID</mat-label>
    <input matInput [(ngModel)]="external_account_id">
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Target Country</mat-label>
    <input matInput [(ngModel)]="target_country">
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Language</mat-label>
    <input matInput [(ngModel)]="language">
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Currency</mat-label>
    <input matInput [(ngModel)]="currency">
  </mat-form-field>

  <mat-form-field appearance="outline" class="field">
    <mat-label>Website URL</mat-label>
    <input matInput [(ngModel)]="website">
  </mat-form-field>

</div>

<div class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</div>
